<template>
  <div class="main">
    <div class="submit-container">
      <div class="left">
        <div class="card-container">
          <div class="heading">Join our team</div>
          <div class="card">
            <div class="card-data">
              <input
                v-if="!openEmail"
                class="github-input"
                type="text"
                v-model="githubLink"
                title="Link to your best GitHub project"
                placeholder="Link to your best GitHub project"
                @keyup.enter="handleClick"
              />
              <input
                v-if="openEmail"
                class="email-input"
                type="email"
                placeholder="Your email address"
                v-model="email"
                @keyup.enter="handleClick"
              />
              <button
                id="submit"
                type="submit"
                name="send"
                @click="handleClick"
                aria-live="polite"
              >
                <img
                  :src="`${baseUrl}/static/icons/long-tail-arrow.svg`"
                  alt=""
                  aria-hidden="true"
                />
              </button>
            </div>
            <div class="text">
              <p v-show="flash">{{ InvalidText }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <NuxtImg
          :src="`${baseUrl}/static/images/group-discusion.jpg`"
          alt="team discussion"
          loading="lazy"
        />
      </div>
    </div>
  </div>
</template>
<script setup>
import axios from "axios";
const config = useRuntimeConfig();
const baseUrl = config.public.NUXT_CDN_URL;
const openEmail = ref(false);
const githubLink = ref("");
const email = ref("");
const flash = ref(false);
const InvalidText = ref("");
const submit = ref(false);

function handleClick() {
  if (!openEmail.value) {
    checkgithubLink();
  } else {
    submitForm();
  }
}

function checkgithubLink() {
  flash.value = false;
  InvalidText.value = "";
  if (githubLink.value.includes("github.com")) {
    openEmail.value = true;
  } else {
    flash.value = true;
    InvalidText.value = "Please enter a valid GitHub link.";
  }
}
const submitForm = async () => {
  try {
    const EmailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!EmailPattern.test(email.value)) {
      flash.value = true;
      InvalidText.value = "Please enter a valid email address.";
      return;
    }
    flash.value = false;
    if (submit.value) return;
    submit.value = true;
    const response = await axios.post(`${config.public.NUXT_API_URL}/contact`, {
      name: "joining the team",
      mobile: "0000000000",
      email: email.value,
      message: `
      GitHub Link: ${githubLink.value}
      msg: Interested in joining the team
      `,
    });
    if (response.status === 200) {
      email.value = "";
      githubLink.value = "";
      flash.value = true;
      InvalidText.value = "Thanks! We'll reach out to you.";
    }
    flash.value = true;
  } catch (error) {
    flash.value = true;
    console.error("Error submitting form:", error);
    InvalidText.value =
      "There was an error submitting the form. Please try again.";
    submit.value = false;
  }

  // Submit the form dat
};
</script>
<style lang="scss" scoped>
.main {
  max-width: 1200px;
  margin: auto;
  margin-bottom: 3rem;
  margin-top: 2rem;
  font-family: inherit;
  width: 100%;
  height: fit-content;
  .submit-container {
    width: 100%;
    display: flex;
    justify-content: space-between;
    // align-items: center;
    @include respond-below(sm) {
      flex-direction: column-reverse;
      height: fit-content;
      gap: 2rem;
    }
    .left {
      width: 50%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-block: auto;
      @include respond-below(lg) {
        width: 40%;
        height: 100%;
        padding: 1rem;
        margin-left: 0.5rem;
      }
      @include respond-below(sm) {
        width: 100%;
        height: fit-content;
        margin: 0;
        padding: 0 2rem;
        justify-content: flex-start;
      }
      .card-container {
        -webkit-backdrop-filter: blur(5px);
        backdrop-filter: blur(5px);
        width: 85%;
        border-radius: 1rem;
        height: 70%;
        display: flex;
        flex-direction: column;
        gap: 1.8rem;
        // justify-content: center;
        // align-items: center;

        @include respond-below(sm) {
          width: 100%;
          gap: 1.5rem;
          // height: 300px;
        }
        .heading {
          font-family: "Book21", "Sharp Grotesk", sans-serif;
          letter-spacing: -5.2px;
          font-weight: 600;
          font-size: clamp(30px, 5vw, 70px);
          // background-image: linear-gradient(
          //   90deg,
          //   #fff 1.51%,
          //   #f9d3a2 50.75%,
          //   #ebbe94 69.53%
          // );
          background-image: linear-gradient(
            90deg,
            #fff 1.51%,
            #5d5be6 18.01%,
            #ffffff 82.09%
          );

          background-clip: text;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          color: transparent;
          @include respond-below(lg) {
            font-size: 3.5rem;
            letter-spacing: -3px;
          }
          @include respond-below(md) {
            font-size: 2.8rem;
            letter-spacing: -2.5px;
          }
          @include respond-below(sm) {
            font-size: 2.2rem;
            letter-spacing: -2px;
          }
        }
        .card {
          // align-items: center;
          width: 100%;
          height: auto;
          display: flex;
          // gap: 0.5rem;
          flex-direction: column;
          gap: 1.8rem;
          @include respond-below(sm) {
            // height: 150px;
            width: 100%;
            gap: 1.2rem;
          }
          input {
            // width: 100px;
            flex: 1;
            padding: 1rem 1.8rem;
            border-radius: 16px;
            border: none;
            font-size: 1.1rem;
            font-weight: 400;
            outline: none;
            background: rgba(255, 255, 255, 0.08);
            border: 2px solid rgba(255, 255, 255, 0.15);
            color: #ffffff;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            backdrop-filter: blur(10px);
            -webkit-backdrop-filter: blur(10px);
            &:focus {
              background: rgba(255, 255, 255, 0.12);
              border-color: rgba(255, 255, 255, 0.3);
              transform: translateY(-1px);
              box-shadow: 0 8px 32px rgba(255, 255, 255, 0.1);

              &::placeholder {
                color: transparent;
                white-space: nowrap;
                text-overflow: ellipsis;
              }
              &::-ms-tooltip {
                display: none;
              }
            }
            @include respond-below(sm) {
              padding: 0.8rem 1rem;
              font-size: 0.9rem;
            }
          }
          .text {
            height: 30px;
            // height: 100px;
            @include respond-below(sm) {
              // height: 70px;
            }
            p {
              font-size: 1.4rem;
              font-weight: 100;
              letter-spacing: 1px;
              color: white;
              line-height: 1.3;
              @include respond-below(sm) {
                font-size: 1rem;
              }
            }
          }
        }
        button {
          border: none;
          cursor: pointer;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          border-radius: 16px;
          background-color: inherit;
          padding: 0.8rem 1.5rem;
          position: relative;
          overflow: hidden;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          min-height: 56px;
          img {
            width: 62px;
            height: 32px;
            object-fit: contain;
          }
          @include respond-below(lg) {
            min-height: unset;
            width: 50%;
            padding: 0rem 0.8rem;
            justify-content: start;
          }
          @include respond-below(sm) {
            width: 100%;
            height: 20px;
            justify-content: flex-end;
          }
        }
      }
    }
    .right {
      width: 50%;
      height: fit-content;
      display: grid;
      place-items: center;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        @include respond-below(sm) {
          width: 85%;
          border-radius: 0.5rem;
          object-fit: inherit;
        }
      }
      @include respond-below(lg) {
        width: 62%;
      }
      @include respond-below(sm) {
        width: 100%;
        height: calc(100% / 1.20689655);
      }
    }
    .card-data {
      text-align: center;
      width: 90%;
      height: auto;
      display: flex;
      gap: 0.5rem;
      @include respond-below(lg) {
        flex-direction: column;
        gap: 1.5rem;
        width: 100%;
      }
    }
  }
}
</style>
